<script>
    import Editor from '@tinymce/tinymce-svelte';
    import Router from "svelte-spa-router";
    import { routes } from "./routes";

    import { addMessages, getLocaleFromNavigator, init } from "svelte-i18n";

    import de from "./i18n/de.json";
    import en from "./i18n/en.json";
    import fr from "./i18n/fr.json";
    import { Toaster } from "svelte-french-toast";

    addMessages("de", de);
    addMessages("en", en);
    addMessages("fr", fr);

    init({
        fallbackLocale: "de",
        // try to load lcoale form storage first, then ask the browser
        initialLocale:
            window.localStorage.getItem("locale") || getLocaleFromNavigator(),
    });
</script>

<Toaster />
<Router {routes} />

<div class="hidden">
    <Editor apiKey="kwkxr2uxajpsfr9iifmxlqioy9004bn5qn1gg91nhbfccxfm" />
</div>
<style>
    .hidden {
        display: none !important;
    }

    /* Font Definitions */
    @font-face {
        font-family: "Trade Gothic LT Std";
        src: url("/fonts/tradegothic-bd2.ttf");
    }

    @font-face {
        font-family: "Trade Gothic";
        src: url("/fonts/TradeGothic.ttf");
        font-weight: 400;
    }

    @font-face {
        font-family: "Trade Gothic";
        src: url("/fonts/tradegothic-bd2.ttf");
        font-weight: 700;
    }

    @font-face {
        font-family: "Trade Gothic";
        src: url("/fonts/tradegothic-light.ttf");
        font-weight: 300;
    }

    @font-face {
        font-family: "FK Grotesk";
        src: url("/fonts/FKGrotesk-Regular.ttf");
        font-weight: 400;
    }

    @font-face {
        font-family: "FK Grotesk";
        src: url("/fonts/FKGrotesk-Medium.ttf");
        font-weight: 500;
    }

    @font-face {
        font-family: "FK Grotesk";
        src: url("/fonts/FKGrotesk-Bold.ttf");
        font-weight: 700;
    }

    @font-face {
        font-family: "FK Grotesk";
        src: url("/fonts/FKGrotesk-Black.ttf");
        font-weight: 900;
    }

    /* Deprecated Fonts */
    @font-face {
        font-family: "Inter";
        src: url("/fonts/deprecated/Inter-Regular.ttf");
        font-weight: normal;
    }

    @font-face {
        font-family: "Inter";
        src: url("/fonts/deprecated/Inter-Bold.ttf");
        font-weight: bold;
    }

    /* Highlight text*/
    :global(::selection) {
        background: var(--black-64);
    }

    :global(::-moz-selection) {
        /* Code for Firefox */
        background: var(--black-64);
    }

    /* CSS CLEANUP */
    :global(body) {
        color: #1a1a17;
        padding: 0;
        background: var(--white-100);
        overflow-x: hidden;
    }

    /* Color vars */
    :global(:root) {
        --black-100: #1a1a17;
        --black-64: rgba(26, 26, 23, 0.64);
        --black-40: rgba(26, 26, 23, 0.4);
        --white-100: #f1f1ee;
        --white-64: rgba(241, 241, 238, 0.64);
        --white-40: rgba(241, 241, 238, 0.4);
        --fb-green: #dce2d3;
        --fb-blue: #b2c2dd;
        --fb-red: #b06166;
        --fb-brown: #b39074;
        font-family: "Trade Gothic", sans-serif;
    }

    /*Icon Hover Effect*/
    :global(.icon:hover) {
        stroke-width: 2px;
        cursor: pointer;
    }

    /* Pointer Cursor*/
    :global(.pCursor) {
        cursor: pointer;
    }

    :global(.imageBlur) {
        transition: 0.25s;
        transition-timing-function: cubic-bezier(0, -0.03, 0.19, 1);
    }

    /*Image HoverBlur Effekt*/
    :global(.imageBlur:hover) {
        filter: blur(6px);
        -webkit-filter: blur(6px);
        cursor: pointer;
    }

    :global(.display-big) {
        display: none;
    }

    /* Background Blurs */

    :global(.bg-blur-l) {
        /* Background Blur/L */
        -webkit-backdrop-filter: blur(60px);
        backdrop-filter: blur(60px);
        /* Note: backdrop-filter has minimal browser support */
    }

    :global(.bg-blur-m) {
        /* Background Blur/M */
        -webkit-backdrop-filter: blur(24px);
        backdrop-filter: blur(24px);
        /* Note: backdrop-filter has minimal browser support */
    }

    :global(.bg-blur-s) {
        /* Background Blur/S */
        -webkit-backdrop-filter: blur(6px);
        backdrop-filter: blur(6px);
        /* Note: backdrop-filter has minimal browser support */
    }

    :global(.backdrop-shadow) {
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    }

    /* Divider */
    :global(.divider-h) {
        width: 100%;
        height: 1px;
        background: var(--black-100);
    }

    :global(.divider-v) {
        width: 1px;
        height: 100%;
        background: var(--black-100);
    }

    :global(.mobile-padding) {
        padding-top: 48px;
        padding-bottom: 32px;
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box;
    }

    :global(.mobile-header-padding) {
        padding-top: 48px;
    }

    :global(.mobile-bottom-padding) {
        padding-bottom: 48px;
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box;
    }

    /* Headlines */
    :global(.headline-l) {
        /* Headline/L */

        font-family: "Trade Gothic LT Std", sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 48px;
        line-height: 95%;
        /* identical to box height, or 46px */

        letter-spacing: -0.04em;
        text-transform: uppercase;

        color: var(--black-100);
    }

    :global(.headline-m) {
        /* Headline/M */

        font-family: "Trade Gothic LT Std", sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 40px;
        line-height: 96%;
        /* identical to box height, or 40px */

        letter-spacing: -0.04em;
        text-transform: uppercase;

        color: var(--black-100);
    }

    :global(.headline-s) {
        /* Headline/S */

        font-family: "Trade Gothic LT Std", sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 100%;
        /* identical to box height, or 24px */

        letter-spacing: -0.02em;
        text-transform: uppercase;

        color: var(--black-100);
    }

    :global(.headline-xs) {
        /* Headline/XS */

        font-family: "Trade Gothic LT Std", sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 96%;
        /* or 19px */
        letter-spacing: -0.02em;

        text-transform: uppercase;

        color: var(--black-100);
    }

    /* Text Styles */

    :global(.text-l) {
        /* Text/L */

        font-family: "Trade Gothic", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 112%;
        letter-spacing: -0.02em;
        /* or 22px */

        color: var(--black-100);
    }

    :global(.text-m) {
        /* Text/M */

        font-family: "Trade Gothic", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 112%;
        letter-spacing: -0.02em;
        /* identical to box height, or 17px */

        color: var(--black-100);
    }

    :global(.text-s) {
        /* Text/S */

        font-family: "FK Grotesk", "GroteskReplacement";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 112%;
        /* or 20px */

        letter-spacing: -0.02em;
        color: var(--black-100);
    }

    :global(::-moz-selection) {
        color: var(--black-40);
        background: transparent;
    }

    :global(::selection) {
        color: var(--black-40);
        background: transparent;
    }

    @media only screen and (min-width: 960px) {
        :global(.headline-l) {
            font-size: 40px;
            line-height: 96%;
        }
    }

    @media only screen and (min-width: 1440px) {
        :global(.headline-l) {
            line-height: 95%;
            font-size: 64px;
        }

        :global(.headline-m) {
            font-size: 48px;
        }

        :global(.headline-s) {
            font-size: 40px;
        }

        :global(.headline-xs) {
            font-size: 24px;
        }

        :global(.text-m) {
            font-size: 18px;
        }

        :global(.text-s) {
            font-size: 14px;
        }

        :global(.display-big) {
            display: flex;
        }

        :global(.display-small) {
            display: none;
        }
    }

    @media only screen and (min-width: 1728px) {
        :global(.headline-l) {
            line-height: 95%;
            font-size: 80px;
        }

        :global(.headline-m) {
            font-size: 56px;
        }
    }
</style>
